(function () {
  function formatIsoDuration(iso) {
    if (!iso || typeof iso !== 'string') return '';
    var match = iso.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/i);
    if (!match) return '';

    var hours = parseInt(match[1] || '0', 10);
    var minutes = parseInt(match[2] || '0', 10);
    var parts = [];

    if (hours) parts.push(hours + (hours === 1 ? ' hour' : ' hours'));
    if (minutes) parts.push(minutes + (minutes === 1 ? ' minute' : ' minutes'));

    return parts.join(' ');
  }

  function getRecipeData(embed) {
    var script = embed.querySelector('script[id^="recipe-data-"]');
    if (!script || !script.textContent) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function getYieldText(data) {
    if (!data) return '';

    return (
      data.serving_size ||
      data.recipe_yield ||
      data.servings ||
      data.recipeYield ||
      ''
    );
  }

  function createMetaBar(data) {
    var totalTime = formatIsoDuration(data && data.iso_total_time);
    var yieldText = getYieldText(data);
    var hasTotal = totalTime.length > 0;
    var hasYield = yieldText.length > 0;

    if (!hasTotal && !hasYield) return null;

    var bar = document.createElement('div');
    bar.className = 'sbrl-rk-meta-bar';

    if (hasTotal) {
      var totalItem = document.createElement('div');
      totalItem.className = 'sbrl-rk-meta-bar__item';
      totalItem.innerHTML =
        '<span class="sbrl-rk-meta-bar__icon sbrl-rk-meta-bar__icon--time" aria-hidden="true"></span>' +
        '<span><strong>Total Time:</strong> ' +
        totalTime +
        '</span>';
      bar.appendChild(totalItem);
    }

    if (hasYield) {
      var yieldItem = document.createElement('div');
      yieldItem.className = 'sbrl-rk-meta-bar__item';
      yieldItem.innerHTML =
        '<span class="sbrl-rk-meta-bar__icon sbrl-rk-meta-bar__icon--yield" aria-hidden="true"></span>' +
        '<span><strong>Yield:</strong> ' +
        yieldText +
        '</span>';
      bar.appendChild(yieldItem);
    }

    return bar;

  }

  var INGREDIENTS_COPY_ICON =
    '<svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M5 5V13C5 13.5304 5.21071 14.0391 5.58579 14.4142C5.96086 14.7893 6.46957 15 7 15H13M5 5V3C5 2.46957 5.21071 1.96086 5.58579 1.58579C5.96086 1.21071 6.46957 1 7 1H11.586C11.8512 1.00006 12.1055 1.10545 12.293 1.293L16.707 5.707C16.8946 5.89449 16.9999 6.1488 17 6.414V13C17 13.5304 16.7893 14.0391 16.4142 14.4142C16.0391 14.7893 15.5304 15 15 15H13M5 5H3C2.46957 5 1.96086 5.21071 1.58579 5.58579C1.21071 5.96086 1 6.46957 1 7V17C1 17.5304 1.21071 18.0391 1.58579 18.4142C1.96086 18.7893 2.46957 19 3 19H11C11.5304 19 12.0391 18.7893 12.4142 18.4142C12.7893 18.0391 13 17.5304 13 17V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  function getIngredientsText(ingredientsEl) {
    var lines = [];

    ingredientsEl.querySelectorAll('li').forEach(function (item) {
      var content = item.querySelector('.rk_ingredient_content');
      var text = (content ? content.textContent : item.textContent || '').replace(/\s+/g, ' ').trim();
      if (text) lines.push(text);
    });

    return lines.join('\n');
  }

  function copyTextToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        document.execCommand('copy');
        resolve();
      } catch (error) {
        reject(error);
      } finally {
        document.body.removeChild(textarea);
      }
    });
  }

  function copyIngredients(ingredientsEl) {
    var text = getIngredientsText(ingredientsEl);
    if (!text) {
      if (window.showInlineFormMessage) {
        window.showInlineFormMessage({
          message: 'No ingredients to copy.',
          type: 'error',
        });
      }
      return Promise.resolve();
    }

    return copyTextToClipboard(text)
      .then(function () {
        if (window.showInlineFormMessage) {
          window.showInlineFormMessage({
            message: 'Ingredients copied!',
            type: 'success',
          });
        }
      })
      .catch(function () {
        if (window.showInlineFormMessage) {
          window.showInlineFormMessage({
            message: 'Unable to copy ingredients. Please try again.',
            type: 'error',
          });
        }
      });
  }

  function ensureIngredientsCopyButton(ingredientsEl) {
    var header = ingredientsEl.querySelector('.rk_ingredients_header');
    if (!header || header.querySelector('.sbrl-ingredients-copy-btn')) return;

    var heading = header.querySelector('.rk_column_heading, .rk_section_header, h2');
    if (!heading) return;

    var wrap = document.createElement('div');
    wrap.className = 'sbrl-ingredients-heading';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'sbrl-ingredients-copy-btn';
    button.setAttribute('aria-label', 'Copy ingredients');
    button.innerHTML = INGREDIENTS_COPY_ICON;
    button.addEventListener('click', function () {
      copyIngredients(ingredientsEl);
    });

    heading.parentNode.insertBefore(wrap, heading);
    wrap.appendChild(heading);
    wrap.appendChild(button);
  }

  function enhanceCookModeLabel(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.rk-cook-mode-label:not([data-sbrl-label-enhanced])').forEach(function (label) {
      var text = label.textContent.replace(/\s+/g, ' ').trim();
      var colonIndex = text.indexOf(':');
      if (colonIndex === -1) return;

      var prefix = text.slice(0, colonIndex).trim();
      var suffix = text.slice(colonIndex + 1).trim();

      label.textContent = '';
      var strong = document.createElement('strong');
      strong.className = 'sbrl-cook-mode-label__prefix';
      strong.textContent = prefix + ':';
      label.appendChild(strong);

      if (suffix) {
        label.appendChild(document.createTextNode(' ' + suffix));
      }

      label.dataset.sbrlLabelEnhanced = '1';
    });
  }

  function getRecipeSettings(embed) {
    var script = embed.querySelector('script#recipe-settings');
    if (!script || !script.textContent) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function noteHasContent(noteHtml) {
    if (!noteHtml || typeof noteHtml !== 'string') return false;
    var probe = document.createElement('div');
    probe.innerHTML = noteHtml;
    return !!probe.textContent.replace(/\s+/g, ' ').trim();
  }

  function renderRecipeNote(embed) {
    var slot = embed.nextElementSibling;
    var slotEl = slot && slot.hasAttribute('data-sbrl-rk-note-slot') ? slot : null;
    if (!slotEl) return false;

    var data = getRecipeData(embed);
    var noteHtml = data && (data.recipe_note || data.recipeNote);

    if (!noteHasContent(noteHtml)) {
      slotEl.hidden = true;
      slotEl.innerHTML = '';
      return false;
    }

    var settings = getRecipeSettings(embed);
    var heading = (settings && settings.lang && settings.lang.note) || 'Note';
    var existing = slotEl.querySelector('.sbrl-rk-note');

    if (existing && existing.dataset.sbrlNoteSource === noteHtml) {
      slotEl.hidden = false;
      return true;
    }

    slotEl.innerHTML = '';
    var wrap = document.createElement('div');
    wrap.className = 'sbrl-rk-note';
    wrap.dataset.sbrlNoteSource = noteHtml;

    var title = document.createElement('h2');
    title.className = 'sbrl-rk-note__heading';
    title.textContent = heading;

    var body = document.createElement('div');
    body.className = 'sbrl-rk-note__body rte';
    body.innerHTML = noteHtml;

    wrap.appendChild(title);
    wrap.appendChild(body);
    slotEl.appendChild(wrap);
    slotEl.hidden = false;
    return true;
  }

  function hydrateRecipeExtras(embed) {
    moveDescriptionOutsideEmbed(embed);
    renderRecipeNote(embed);
  }

  function moveDescriptionOutsideEmbed(embed) {
    var slot = embed.previousElementSibling;
    var slotEl = slot && slot.hasAttribute('data-sbrl-rk-description-slot') ? slot : null;
    var card = embed.querySelector('#rk_parent .rk_card');
    var description = card ? card.querySelector('.rk_description') : null;
    var existingTop = slotEl
      ? slotEl.querySelector('.sbrl-rk-description')
      : embed.parentElement
        ? embed.parentElement.querySelector(':scope > .sbrl-rk-description')
        : null;

    if (description) {
      if (!description.textContent.replace(/\s+/g, ' ').trim()) {
        description.remove();
        if (slotEl) slotEl.hidden = true;
        return false;
      }

      description.classList.add('sbrl-rk-description');
      if (existingTop && existingTop !== description) existingTop.remove();

      if (slotEl) {
        slotEl.hidden = false;
        slotEl.appendChild(description);
      } else if (embed.parentNode) {
        embed.parentNode.insertBefore(description, embed);
      }

      return true;
    }

    if (existingTop) {
      if (slotEl) slotEl.hidden = false;
      return true;
    }

    if (slotEl) slotEl.hidden = true;
    return false;
  }

  function reorderRecipeKit(embed) {
    hydrateRecipeExtras(embed);

    var card = embed.querySelector('#rk_parent .rk_card');
    if (!card) return false;

    if (card.dataset.sbrlReordered === 'true' && card.querySelector('.rk_header')) {
      card.dataset.sbrlReordered = 'false';
    }

    var hero = card.querySelector('.rk_header > .rk_grid:first-child');
    var ingredients = card.querySelector('.rk_ingredients');
    if (!hero || !ingredients) return false;

    if (card.dataset.sbrlReordered === 'true') {
      ensureIngredientsCopyButton(ingredients);
      enhanceCookModeLabel(embed);
      bindDirectionSteps(embed);
      hydrateRecipeExtras(embed);
      return true;
    }

    var cookModeWrap = card.querySelector('.rk-cook-mode-wrapper');
    var cookModeBlock = cookModeWrap;
    var divider =
      card.querySelector('.rk_body > span.rk_hr') ||
      card.querySelector('.rk_body > .rk_hr:not(:first-child)');
    var directions = card.querySelector('.rk_directions');
    var footerMeta = card.querySelector('.rk_column.rk_details > .rk_grid');
    var data = getRecipeData(embed);
    var metaBar = createMetaBar(data);

    var ordered = [hero];
    if (metaBar) ordered.push(metaBar);
    ordered.push(ingredients);
    if (cookModeBlock) ordered.push(cookModeBlock);
    if (divider) ordered.push(divider);
    if (directions) ordered.push(directions);
    if (footerMeta) ordered.push(footerMeta);

    var fragment = document.createDocumentFragment();
    ordered.forEach(function (node) {
      if (node) fragment.appendChild(node);
    });

    while (card.firstChild) {
      card.removeChild(card.firstChild);
    }

    card.appendChild(fragment);
    card.dataset.sbrlReordered = 'true';
    ensureIngredientsCopyButton(ingredients);
    enhanceCookModeLabel(embed);
    bindDirectionSteps(embed);
    hydrateRecipeExtras(embed);

    return true;
  }

  function bindDirectionSteps(embed) {
    if (embed.dataset.sbrlStepsBound === 'true') return;

    embed.addEventListener(
      'click',
      function (event) {
        var label = event.target.closest('.rk_directions .rk_step_label');
        if (!label) return;

        var checkbox = label.querySelector('input.rk_checkbox[type="checkbox"]');
        if (!checkbox) return;

        if (event.target === checkbox) {
          syncDirectionStepState(checkbox);
          return;
        }

        event.preventDefault();
        checkbox.checked = !checkbox.checked;
        syncDirectionStepState(checkbox);
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      },
      true
    );

    embed.addEventListener('change', function (event) {
      if (event.target.matches('.rk_directions .rk_checkbox')) {
        syncDirectionStepState(event.target);
      }
    });

    embed.querySelectorAll('.rk_directions .rk_checkbox').forEach(syncDirectionStepState);
    embed.dataset.sbrlStepsBound = 'true';
  }

  function syncDirectionStepState(checkbox) {
    var item = checkbox.closest('li');
    if (!item) return;
    item.classList.toggle('user_checked', checkbox.checked);
  }

  function hasRecipeContent(embed) {
    return !!embed.querySelector('recipe-kit, #rk_parent');
  }

  function cleanupRecipeEmbed() {
    document.querySelectorAll('.sbrl-recipe-embed').forEach(function (embed) {
      embed.querySelectorAll('.sbrl-recipe-embed__app').forEach(function (app) {
        var block = app.querySelector('.shopify-block');
        if (block && block.textContent.trim() === '' && !hasRecipeContent(app)) {
          app.remove();
        }
      });

      if (!hasRecipeContent(embed)) {
        embed.remove();
      }
    });
  }

  function bindNewsletterForms(root) {
    root.querySelectorAll('.sbrl-newsletter-form').forEach(function (form) {
      if (form.dataset.sbrlAjaxBound === '1') return;
      form.dataset.sbrlAjaxBound = '1';

      var action = form.action;
      var block = form.closest('[data-success-message]');
      var successMessage =
        (block && block.getAttribute('data-success-message')) || 'Thanks for subscribing!';

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        var input = form.querySelector('input[type="email"]');
        var btn = form.querySelector('button[type="submit"]');
        if (!input || !btn) return;

        var email = input.value.trim();
        if (!email) return;

        var btnText = btn.textContent;
        btn.textContent = '...';
        btn.disabled = true;

        fetch(action, {
          method: 'POST',
          body: new FormData(form),
        })
          .then(function () {
            input.value = '';
            if (window.showInlineFormMessage) {
              window.showInlineFormMessage({ message: successMessage, type: 'success' });
            }
          })
          .catch(function () {
            if (window.showInlineFormMessage) {
              window.showInlineFormMessage({
                message: 'Something went wrong. Please try again.',
                type: 'error',
              });
            }
          })
          .finally(function () {
            btn.textContent = btnText;
            btn.disabled = false;
          });

        return false;
      });
    });
  }

  function initEmbeds() {
    document.querySelectorAll('.sbrl-recipe-embed').forEach(function (embed) {
      reorderRecipeKit(embed);
      bindDirectionSteps(embed);
      enhanceCookModeLabel(embed);
    });
  }

  function boot() {
    bindNewsletterForms(document);
    initEmbeds();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = document.getElementById('shopify-section-' + event.detail.sectionId);
    if (!root) return;
    bindNewsletterForms(root);
    root.querySelectorAll('.sbrl-recipe-embed').forEach(function (embed) {
      reorderRecipeKit(embed);
      bindDirectionSteps(embed);
      enhanceCookModeLabel(embed);
    });
  });

  window.addEventListener('load', function () {
    setTimeout(initEmbeds, 300);
    setTimeout(initEmbeds, 1200);
    setTimeout(function () {
      cleanupRecipeEmbed();
      initEmbeds();
    }, 2500);
  });

  document.querySelectorAll('.sbrl-recipe-embed').forEach(function (embed) {
    var observer = new MutationObserver(function () {
      reorderRecipeKit(embed);
      hydrateRecipeExtras(embed);
    });

    observer.observe(embed, {
      childList: true,
      subtree: true,
    });
  });
})();
